// extracted by mini-css-extract-plugin
export default {"button":"Button_button__gX1K-","loading":"Button_loading__WpRHF","enabled":"Button_enabled__BqGhP","disabled":"Button_disabled__hafu+","text":"Button_text__t6bjA"};